import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { VideoProvider, useVideo } from './context/VideoContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import ProjectDetail from './pages/ProjectDetail';
import Directory from './pages/Directory';
import Winners from './pages/Winners';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ComingSoon from './pages/ComingSoon';
import Truth from './pages/Truth';
import ErrorPage from './pages/ErrorPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ErrorBoundary from './components/ErrorBoundary';
import Footer from './components/Footer';
import './App.css';

const AppContent = () => {
  const [isOffline, setIsOffline] = useState(!window.navigator.onLine);
  const { error } = useVideo();
  const { role, loading: authLoading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOffline) return <ErrorPage errorCode="offline" />;
  if (error) return <ErrorPage errorCode="500" />;

  const isComingSoon = false;
  const isLoginPage = location.pathname === '/user';
  const isAdmin = role === 'admin';

  if (isComingSoon && !authLoading && !isAdmin && !isLoginPage) {
    return <ComingSoon />;
  }

  return (
    <div className="app flex flex-col min-h-screen">
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:slug" element={<ProjectDetail />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/winners" element={<Winners />} />
          <Route path="/truth" element={<Truth />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/user" element={<Login />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage errorCode="404" />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <VideoProvider>
        <Router>
          <ErrorBoundary>
            <AppContent />
          </ErrorBoundary>
        </Router>
      </VideoProvider>
    </AuthProvider>
  );
}

export default App;